import React from 'react';

const SelectInput = ({
  name,
  label,
  options,
  value,
  onChange,
  disabled,
  error,
  touched,
  className,
  required,
  additionalContent,
  placeholder,
  defaultValue,
}) => {
  return (
    <div className="form-field-container">
      <div className="input-section-container">
        {label && (
          <div className="form-label-container">
            <h5 className="form-label">
              {label}
              <span style={{ color: 'red' }}> {required ? '*' : ' '}</span>
            </h5>
          </div>
        )}

        <div className="col-container">
          <div className={className}>
            <select
              name={name}
              className="form-select"
              value={value}
              onChange={onChange}
              disabled={disabled}
              defaultValue={defaultValue}
            >
              <option value="">
                {placeholder ? placeholder : '请选择'}
                {label}
              </option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {additionalContent}
      {error && touched && <div className="error">{error}</div>}
    </div>
  );
};

export default SelectInput;
